import { useTranslation } from 'react-i18next';
import React from 'react';
import { tField } from '../../utils/bilingualHelper';

export default function BatchBreakdownTable({ batchBreakdown, onSelectBatch }) {
  const { t } = useTranslation();
  if (!batchBreakdown || batchBreakdown.length === 0) {
    return (
      <div className="dash-card" style={{ padding: '40px', textAlign: 'center', color: '#7a7068' }}>{t('financialHub.noBatchData')}</div>
    );
  }

  return (
    <div className="dash-card" style={{ padding: '0 0 20px' }}>
      <div className="dash-card-header" style={{ padding: '24px 30px', borderBottom: '1px solid #eee' }}>
        <div>
          <div className="dash-card-title" style={{ fontSize: 18 }}>📖 {t('financialHub.batchHealth')}</div>
          <div style={{ fontSize: 12, color: 'var(--mid-grey)', marginTop: 4 }}>💡 {t('financialHub.batchHealthSub')}</div>
        </div>
      </div>

      {/* Desktop Table View */}
      <div className="financial-desktop-table" style={{ overflowX: 'auto', padding: '0 20px 20px' }}>
        <table style={{ width: '100%', borderCollapse: 'separate', borderSpacing: '0 10px' }}>
          <thead>
            <tr style={{ background: '#f8f9fa' }}>
              <th style={{ padding: '15px 20px', textAlign: 'left', fontSize: 11, textTransform: 'uppercase', color: '#7a7068', borderBottom: '2px solid #eee' }}>{t('financialHub.batchName')}</th>
              <th style={{ padding: '15px 20px', textAlign: 'center', fontSize: 11, textTransform: 'uppercase', color: '#7a7068', borderBottom: '2px solid #eee' }}>{t('financialHub.standardFee')}</th>
              <th style={{ padding: '15px 20px', textAlign: 'center', fontSize: 11, textTransform: 'uppercase', color: '#7a7068', borderBottom: '2px solid #eee' }}>{t('financialHub.students')}</th>
              <th style={{ padding: '15px 20px', textAlign: 'right', fontSize: 11, textTransform: 'uppercase', color: '#7a7068', borderBottom: '2px solid #eee' }}>{t('financialHub.totalExpected')}</th>
              <th style={{ padding: '15px 20px', textAlign: 'right', fontSize: 11, textTransform: 'uppercase', color: '#7a7068', borderBottom: '2px solid #eee' }}>{t('financialHub.totalCollected')}</th>
              <th style={{ padding: '15px 20px', textAlign: 'right', fontSize: 11, textTransform: 'uppercase', color: '#7a7068', borderBottom: '2px solid #eee' }}>{t('financialHub.arrears')}</th>
              <th style={{ padding: '15px 20px', textAlign: 'center', fontSize: 11, textTransform: 'uppercase', color: '#7a7068', borderBottom: '2px solid #eee' }}>{t('financialHub.efficiency')}</th>
            </tr>
          </thead>
          <tbody>
            {batchBreakdown.map((batch, index) => {
              const efficiency = batch.totalExpected > 0 ? ((batch.collected / batch.totalExpected) * 100).toFixed(0) : 100;
              return (
                <tr key={batch.id || batch._id || index} 
                  style={{ transition: 'all 0.2s ease', cursor: 'pointer' }} 
                  className="table-row-hover"
                  onClick={() => onSelectBatch(batch)}>
                  <td style={{ padding: '15px 20px', fontWeight: 700, color: 'var(--wine)' }}>{tField(batch.name)} 🔍</td>
                  <td style={{ padding: '15px 20px', textAlign: 'center', color: '#555' }}>${batch.standardFee}</td>
                  <td style={{ padding: '15px 20px', textAlign: 'center', fontWeight: 600 }}>{batch.studentCount}</td>
                  <td style={{ padding: '15px 20px', textAlign: 'right', fontWeight: 800 }}>${batch.totalExpected?.toLocaleString()}</td>
                  <td style={{ padding: '15px 20px', textAlign: 'right', color: '#2d7a52', fontWeight: 700 }}>${batch.collected?.toLocaleString()}</td>
                  <td style={{ padding: '15px 20px', textAlign: 'right', color: batch.arrears > 0 ? '#c0392b' : '#2d7a52', fontWeight: 700 }}>
                    ${batch.arrears?.toLocaleString()}
                  </td>
                  <td style={{ padding: '15px 20px', textAlign: 'center' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 10, justifyContent: 'center' }}>
                       <div style={{ width: 60, height: 6, background: '#eee', borderRadius: 10, overflow: 'hidden' }}>
                          <div style={{ width: `${efficiency}%`, height: '100%', background: efficiency === '100' ? '#2d7a52' : '#c0692b' }}></div>
                       </div>
                       <span style={{ fontSize: 11, fontWeight: 800, minWidth: 35 }}>{efficiency}%</span>
                     </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {/* Mobile Card View */}
      <div className="financial-mobile-cards" style={{ padding: '0 20px' }}>
        {batchBreakdown.map((batch, index) => {
          const efficiency = batch.totalExpected > 0 ? ((batch.collected / batch.totalExpected) * 100).toFixed(0) : 100;
          return (
            <div 
              key={batch.id || batch._id || index}
              className="batch-financial-mobile-card"
              onClick={() => onSelectBatch(batch)}
            >
              <div className="batch-card-header">
                <span className="batch-card-title">{tField(batch.name)} 🔍</span>
                <span className="badge badge-gold" style={{ fontSize: '10px' }}>{t('financialHub.standardFee')}: ${batch.standardFee}</span>
              </div>
              <div className="batch-card-grid">
                <div className="batch-card-stat">
                  {t('financialHub.students')}: <strong>{batch.studentCount}</strong>
                </div>
                <div className="batch-card-stat">
                  {t('financialHub.totalExpected')}: <strong>${batch.totalExpected?.toLocaleString()}</strong>
                </div>
                <div className="batch-card-stat">
                  {t('financialHub.totalCollected')}: <strong style={{ color: '#2d7a52' }}>${batch.collected?.toLocaleString()}</strong>
                </div>
                <div className="batch-card-stat">
                  {t('financialHub.arrears')}: <strong style={{ color: batch.arrears > 0 ? '#c0392b' : '#2d7a52' }}>${batch.arrears?.toLocaleString()}</strong>
                </div>
              </div>
              <div className="batch-card-efficiency-row">
                <span>{t('financialHub.collectionEff')}</span>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                  <div style={{ width: 50, height: 6, background: '#eee', borderRadius: 10, overflow: 'hidden' }}>
                    <div style={{ width: `${efficiency}%`, height: '100%', background: efficiency === '100' ? '#2d7a52' : '#c0692b' }}></div>
                  </div>
                  <span style={{ fontSize: 11, fontWeight: 800 }}>{efficiency}%</span>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
